export default {
  SET_USER_LOGIN_UPDATE(state, params) {
    state.param = params;
  },

  SET_USER_SELECT(state, params) {
    state.userEtcInfo = params;
  },

  SET_DIVISION_INFO(state, params) {
    state.divisionInfo = params;
  },

  SET_ALL_DIVISION_INFO(state, params) {
    state.allDivisionInfo = params;
  },

  SET_USER_DIV_INFO(state, params) {
    state.userDivisionInfo = params;
  },

  SET_USER_DIV_DATA(state, params) {
    state.userDivisionList = params;
  },

  SET_DIV_SELECT_ONE(state, params) {
    state.divSelectOne = params;
  },

  SET_CURRENT_DIV_LIST(state, params) {
    state.currentDivList = params;
  },

  SET_SEARCH_ROLE(state, params) {
    state.selectRole = params;
  },

  SET_DIV_WITH_SECURITY_MGMT(state, params) {
    state.divisionListWithSecurityMgmt = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/userdiv/userdivMutation.js